/**
 * Generate avatar initials from a name
 * Example: "Naveen Kumar" -> "NK", "Naveen" -> "NA"
 */
export const getAvatarInitials = (name: string): string => {
  if (!name) return '';
  
  const words = name.trim().split(/\s+/);
  
  if (words.length === 1) {
    // Single word: take first two letters
    return words[0].substring(0, 2).toUpperCase();
  }
  
  // Multiple words: take first letter of first two words
  return (words[0][0] + words[1][0]).toUpperCase();
};

